import { queryOptions } from '@tanstack/react-query';

import { getBannersRequest, getSportsRequest } from './app.requests';

export const getSportsOptions = () =>
  queryOptions({
    queryFn: () => getSportsRequest(),
    queryKey: ['sports'],
  });

export const getBannersOptions = () =>
  queryOptions({
    queryFn: () => getBannersRequest(),
    queryKey: ['banners'],
  });
